import { useEffect } from "react";

export const CemtrickScript = ({ apiKey, code }) => {
  useEffect(() => {
    const inlineScript = document.createElement("script");

    inlineScript.setAttribute("src", `https://interceptor.cemtrik.com/interceptor.js?code=${code}&key=${apiKey}`);
    document.body.appendChild(inlineScript);

    return () => {
      document.body.removeChild(inlineScript);
    };
  }, [code, apiKey]);

  return null;
};
